var _desc, _linearGradient, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 100,
    viewBox: "0 0 100 100",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Magnify Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "An icon representing a magnifying glass, often used in interfaces to symbolize search or zoom functionality.")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 50.0659,
    x2: 50.0659,
    y1: 3,
    y2: 96.966
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313131"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m41 72c17.1208 0 31-13.8792 31-31s-13.8792-31-31-31-31 13.8792-31 31 13.8792 31 31 31z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m66.1447 40.5c0 14.1632-11.4815 25.6447-25.6447 25.6447s-25.6447-11.4815-25.6447-25.6447 11.4815-25.6447 25.6447-25.6447 25.6447 11.4815 25.6447 25.6447zm-25.6447 38.5c8.804 0 16.9201-2.9563 23.4062-7.9296l3.531 3.531-1.137 1.137c-.9599.9599-.9599 2.5161 0 3.476l16.2427 16.2427c3.5661 3.5662 9.348 3.5662 12.9142 0s3.5662-9.348 0-12.9142l-16.2427-16.2427c-.9599-.9599-2.5161-.9599-3.476 0l-1.137 1.137-3.531-3.531c4.9733-6.4861 7.9296-14.6022 7.9296-23.4062 0-21.263-17.237-38.5-38.5-38.5s-38.5 17.237-38.5 38.5 17.237 38.5 38.5 38.5z",
    fill: "url(#a)",
    stroke: "#fff",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ccc"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m20.2173 44.0004c.1618 1.1264 1.7968.8597 1.9576-.2669.3921-2.7468 1.2156-5.9475 2.6914-9.3706 1.8488-4.288 5.3544-5.7833 8.1759-6.9869 1.5107-.6444 2.7054-.6975 3.5844-2.0661 1.752-2.7279-2.949-5.1523-8.1105-1.3364-5.1616 3.816-8.5161 9.9972-8.5161 16.9735 0 1.0371.0741 2.0566.2173 3.0534z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 22.5,
    r: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.10a388cf5465ddcb80a07f0212ff2e7c.svg";
export { ForwardRef as ReactComponent };